module.exports = __webpack_public_path__ + "img/yacht-6.c787d890.jpg";